import { Switch as RadixSwitch } from "radix-ui";
import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";

export const Switch = ({ className, ...props }: ComponentProps<typeof RadixSwitch.Root>) => (
  <RadixSwitch.Root
    className={cn(
      "relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full bg-border-strong transition-colors",
      "data-[state=checked]:bg-primary disabled:cursor-not-allowed disabled:opacity-60",
      className,
    )}
    {...props}
  >
    <RadixSwitch.Thumb className="block size-5 translate-x-0.5 rounded-full bg-white shadow transition-transform data-[state=checked]:translate-x-[22px]" />
  </RadixSwitch.Root>
);
